import dayjs from 'dayjs';
import { PARAMS_EXPIRY_DAYS } from '../constants';
import { getDeviceType } from './getDeviceType';
import { getReferrerDomain } from './getReferrerDomain';
import { hasCookie } from './hasCookie';

const setCookie = (name: string, value: string): void => {
  const expireDate = dayjs().add(PARAMS_EXPIRY_DAYS, 'day').toDate();

  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expireDate.toUTCString()}; path=/; SameSite=Lax;`;
};

export const setTrackingContextToCookie = (): void => {
  if (!hasCookie('referrer')) {
    const referrer = getReferrerDomain();

    if (referrer) {
      setCookie('referrer', referrer);
    }
  }

  if (!hasCookie('device')) {
    setCookie('device', getDeviceType());
  }
};
